export class InternalPositionInUseError extends Error {
  constructor() {
    super('The position is currently in use and cannot be deleted')
    Object.setPrototypeOf(this, InternalPositionInUseError.prototype)
  }
}
